import "./addNewUserTable.css";
import "./addNewUserTableDark.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import axios from "axios";
import ModalFromEdit from "../modalForEditTable/modalForEditTable";
import { fetchUsers } from "../../../../../redux/reducer/postFetcReducer/action/action";
import { useDispatch, useSelector } from "react-redux";
import { Loading, Grid } from "@nextui-org/react";
import { getmyinfoAction } from "../../../../../redux/reducer/getmyinfo/action/action";
import { getMyImageAction } from "../../../../../redux/reducer/getMyimg/action/action";

import DeletWorkersInCopmay from "../deleteWorker/deleteWorker";
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'
import sockets from "../../../../../socket/socket";

export default function AddNewUserTable({ handleShow, workers }) {
  const getDarkModoe = useSelector(darkModes => darkModes)

  const socket = sockets;
  const dipatch = useDispatch()
  const [shows, setShows] = useState(false)
  const [currentDate, SetcurrentDate] = useState({})
  const [load, setLoad] = useState(false)
  const useData = useSelector(datas => datas)
  const myinfos = useSelector(data => data.getMyImageReducer

  )
  let getCompanyID = useSelector(compID => compID.checkedSessionReducer);
  let onlineUSers = useSelector(onlineUSers => onlineUSers);
  let getmyifno = useSelector(myinfo=>myinfo)
  //для редактирование сотрудника
  useEffect(() => {

    dipatch(fetchUsers())
    dipatch(getmyinfoAction("/registration/v2/api"))
    dipatch(getMyImageAction("/registration/v2/api"))

  }, [dipatch])
  // SOCKET UPDATE IN CLIENT

  useEffect(() => {

    socket.on('updateemployee', (users) => {
      dipatch(fetchUsers())
    });



    return () => {
      socket.off('updateemployee');
      socket.off('disconnect');


    };
  }, [])

  const openModalEdit = (empoloys) => {
    setShows(true)
    SetcurrentDate(empoloys)
    dipatch(fetchUsers())
  }
  //используйте эту функцию, чтобы удалить сотрудника

  const deleteWorker = (deleteWorker) => {
    setLoad(true)

    axios.delete('/alldeploy/api',
      { data: { deleteWorker } }
    ).then(deletes => {

      // SOCKET UPDATE IN SERVER
      socket.emit('updateemployeeServerSocket', { companyIDS: getCompanyID.checkedSession });
      toast.success(deletes.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }).catch(error => {
      // SOCKET UPDATE IN SERVER
      socket.emit('updateemployeeServerSocket', { companyIDS: getCompanyID.checkedSession });
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    }).finally(fin => {
      // SOCKET UPDATE IN SERVER
      socket.emit('updateemployeeServerSocket', { companyIDS: getCompanyID.checkedSession });
      dipatch(fetchUsers())
      setLoad(false)
    })
  }


  if (useData.rootReducer.users.data == "") {
    return <h2>У вас еще нет сотрудников</h2>
  }

  



  return (
    <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "contsatrudnikTableDark" : "contsatrudnikTable"}>
      < ModalFromEdit shows={shows} currentDate={currentDate} setShows={setShows} />
      {(useData.rootReducer.users.length < 1) ?


        <h2 style={{ textAlign: "center" }}>У вас еще нет сотрудника</h2>
        :
        <div>
          <table className={getDarkModoe.ToggleDarkModeReducer.chekced ? "employListTableDardk" : "employListTableLigth"} >

            <thead>

              <tr>

                <th className="THIMG">Изображение</th>
                <th>Имя</th>
                <th className="EMAIL">Электронная почта</th>
                <th>Номер телефона</th>
                <th >Роль</th>
                <th style={{ textAlign: "center" }} >Ваши действия</th>
              </tr>
            </thead>
            <tbody>
              {/* admin  здесь данные владелец компании */}
              <tr >

                <td className="THIMGTD">
                  {
                    getmyifno.rootReducer.users.adminInfo?.online?
                    <Avatar size={"lg"} src={useData.rootReducer.users.adminInfo.img ?  useData.rootReducer.users.adminInfo.img : "https://bit.ly/broken-link"}>
                    <AvatarBadge boxSize='1em' bg='green.500' />
                  </Avatar>
                    :
                   <Avatar size={"lg"} src={useData.rootReducer.users.adminInfo.img ?  useData.rootReducer.users.adminInfo.img : "https://bit.ly/broken-link"}/>
                  }
                 

                  {/* <img src={useData.rootReducer.users.adminInfo.img?"http://localhost:5000/"+useData.rootReducer.users.adminInfo.img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTe0qkX7CGP28JHWYVUlbUOAe27r9YPPx0SqgiYJV9rWMlFvMPXuhswH4xaWyIrYF9xWY&usqp=CAU"}/> */}
                </td>
                <td>{useData.rootReducer.users.adminInfo.name}</td>
                <td className="EMAIL">{useData.rootReducer.users.adminInfo.email}</td>
                <td>{useData.rootReducer.users.adminInfo.tel}</td>
                <td className="activeButton"><div>Владелец</div></td>
                <td>



                </td>

              </tr>
              {/* ================================================================ */}
              {/* my wokers если в компании есть сотрудник, то выводим на экран*/}
              {<h2>У вас еще нет сотрудника</h2> && workers?.map((item, data) => {
                   
                // console.log(useData.getMyCompanyAPIReducer.company.ownerofcompanyID);
                if (myinfos.users.data) {
                  if (myinfos.users.data._id == useData.getMyCompanyAPIReducer.company.ownerofcompanyID) {
                    return (
                      <tr key={item._id}>

                        <td className="THIMGTD">
                        {
                    onlineUSers.getOnlineUserViaRouterReducer.users.data?.includes(item.workerID) ?
                            <Avatar size="lg"  src={item.img ? `/${item.img}` : "https://bit.ly/broken-link"} >
                              <AvatarBadge boxSize='0.9em' bg='green.500' />
                            </Avatar>
                            :
                            <Avatar size="lg"  src={item.img ? `/${item.img}` : "https://bit.ly/broken-link"} />
                        }
                         
                          {/* <img src={item.img?item.img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTe0qkX7CGP28JHWYVUlbUOAe27r9YPPx0SqgiYJV9rWMlFvMPXuhswH4xaWyIrYF9xWY&usqp=CAU"}/> */}
                        </td>
                        <td>{item.name}</td>
                        <td className="EMAIL">{item.email}</td>
                        <td>{item.tel}</td>
                        <td className="activeButton"><div onClick={() => openModalEdit(item)}>{item.rols}</div></td>
                        <td className="deletrTD">



                          <DeletWorkersInCopmay item={item} btnload={load} />

                        </td>

                      </tr>
                    )
                  } else {
                    //
                    return (
                      <tr key={item._id}>

                        <td className="THIMGTD">
                        {
                          onlineUSers.getOnlineUserViaRouterReducer.users.data?.includes(item.workerID) ?
                            <Avatar size="lg"  src={item.img ? `/${item.img}` : "https://bit.ly/broken-link"} >
                              <AvatarBadge boxSize='0.9em' bg='green.500' />
                            </Avatar>
                            :
                            <Avatar size="lg"  src={item.img ? `/${item.img}` : "https://bit.ly/broken-link"} />
                        }
                          {/* <img src={item.img?item.img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTe0qkX7CGP28JHWYVUlbUOAe27r9YPPx0SqgiYJV9rWMlFvMPXuhswH4xaWyIrYF9xWY&usqp=CAU"}/> */}
                        </td>
                        <td>{item.name}</td>
                        <td className="EMAIL">{item.email}</td>
                        <td>{item.tel}</td>
                        <td className="activeButton"><div  >{item.rols}</div></td>
                        <td className="deletrTD">


                          {(() => {
                            if (item.tel == useData.getMayInfoReducer.myinfo.tel) {
                              return <DeletWorkersInCopmay item={item} btnload={load} />

                            }
                          })()}



                        </td>

                      </tr>
                    )
                  }
                }



              })}
            </tbody>
          </table>
          
          <div className="forMobileLight">
            <label className={getDarkModoe.ToggleDarkModeReducer.chekced ? "searchEmployDark" : "searchEmploy"} htmlFor="searchEmploy">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8005 14.1003H14.1685L13.9445 13.8843C14.9045 12.7643 15.4005 11.2363 15.1285 9.6123C14.7525 7.3883 12.8965 5.61231 10.6565 5.34031C7.27255 4.92431 4.42455 7.77231 4.84055 11.1563C5.11255 13.3963 6.88855 15.2523 9.11255 15.6283C10.7365 15.9003 12.2645 15.4043 13.3845 14.4443L13.6005 14.6683V15.3003L17.0005 18.7003C17.3285 19.0283 17.8645 19.0283 18.1925 18.7003C18.5205 18.3723 18.5205 17.8363 18.1925 17.5083L14.8005 14.1003ZM10.0005 14.1003C8.00855 14.1003 6.40055 12.4923 6.40055 10.5003C6.40055 8.5083 8.00855 6.9003 10.0005 6.9003C11.9925 6.9003 13.6005 8.5083 13.6005 10.5003C13.6005 12.4923 11.9925 14.1003 10.0005 14.1003Z" fill="#C3CAD9" />
              </svg>
              <input type="text" placeholder="Поиск cотрудников" id="searchEmploy" />
            </label>
            <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "contMobileTableDark" : "contMobileTableLight"}>

              {<h2>У вас еще нет сотрудника</h2> && workers?.map((item, index) => {
             
                if (myinfos.users.data) {
                  if (myinfos.users.data._id == useData.getMyCompanyAPIReducer.company.ownerofcompanyID) {
                    return (
                      <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "childContemploysDark" : "childContemploys"} key={index}>
                        <div className="infoCont">
                          <img src={item.img ? item.img : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTe0qkX7CGP28JHWYVUlbUOAe27r9YPPx0SqgiYJV9rWMlFvMPXuhswH4xaWyIrYF9xWY&usqp=CAU"} />
                          <div>
                            <p className="name">{item.name}</p>
                            <p className="email">{item.email}</p>
                            <p className="tel">{item.tel}</p>
                          </div>
                        </div>
                        <div className="RolasDeleteCont">
                          <p onClick={() => openModalEdit(item)} className="rols">{item.rols}</p>
                          <button onClick={() => deleteWorker(item)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                              <path d="M2.61933 15.0571C2.19142 15.0571 1.8251 14.9343 1.52038 14.6885C1.21565 14.4428 1.06329 14.1474 1.06329 13.8024V1.88214H0V0.627379H4.87558V0H11.7221V0.627379H16.5977V1.88214H15.5344V13.8024C15.5344 14.137 15.3788 14.4298 15.0676 14.6807C14.7564 14.9317 14.3933 15.0571 13.9783 15.0571H2.61933ZM13.9783 1.88214H2.61933V13.8024H13.9783V1.88214ZM5.36832 12.0039H6.92435V3.65972H5.36832V12.0039ZM9.67335 12.0039H11.2294V3.65972H9.67335V12.0039Z" fill="#E62E7B" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    )
                  } else {
                    return (
                      <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "childContemploysDark" : "childContemploys"} key={index}>
                        <div className="infoCont">
                          <img src={item.img ? item.img : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTe0qkX7CGP28JHWYVUlbUOAe27r9YPPx0SqgiYJV9rWMlFvMPXuhswH4xaWyIrYF9xWY&usqp=CAU"} />
                          <div>
                            <p className="name">{item.name}</p>
                            <p className="email">{item.email}</p>
                            <p className="tel">{item.tel}</p>
                          </div>
                        </div>
                        <div className="RolasDeleteCont">
                          <p className="rols">{item.rols}</p>
                          {(() => {
                            if (item.tel == useData.getMayInfoReducer.myinfo.tel) {
                              if (load) {
                                return <Loading type="points" />
                              } else {
                                return (
                                  <button onClick={() => deleteWorker(item)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                      <path d="M2.61933 15.0571C2.19142 15.0571 1.8251 14.9343 1.52038 14.6885C1.21565 14.4428 1.06329 14.1474 1.06329 13.8024V1.88214H0V0.627379H4.87558V0H11.7221V0.627379H16.5977V1.88214H15.5344V13.8024C15.5344 14.137 15.3788 14.4298 15.0676 14.6807C14.7564 14.9317 14.3933 15.0571 13.9783 15.0571H2.61933ZM13.9783 1.88214H2.61933V13.8024H13.9783V1.88214ZM5.36832 12.0039H6.92435V3.65972H5.36832V12.0039ZM9.67335 12.0039H11.2294V3.65972H9.67335V12.0039Z" fill="#E62E7B" />
                                    </svg>
                                  </button>
                                )
                              }

                            }
                          })()}
                        </div>
                      </div>
                    )
                  }
                }

              })}

            </div>
            <div className="addEmploysMobileBTNCont">
              <button className="addEmploysMobileBTN" onClick={handleShow}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24" fill="none">
                  <path d="M2.50569 13.1739C6.07246 10.6087 11.8892 10.6087 15.4815 13.1739C17.1051 14.3461 18 15.9321 18 17.6284C18 19.3248 17.1051 20.897 15.4943 22.0554C13.7045 23.3518 11.3523 24 9.00002 24C6.64775 24 4.29547 23.3518 2.50569 22.0554C0.894888 20.8832 0 19.311 0 17.6009C0.012785 15.9045 0.894888 14.3323 2.50569 13.1739ZM6.4432 18.6628H8.04122V20.3867C8.04122 20.9521 8.47588 21.421 9.00002 21.421C9.52417 21.421 9.95883 20.9521 9.95883 20.3867V18.6628H11.5569C12.0809 18.6628 12.5156 18.1939 12.5156 17.6284C12.5156 17.063 12.0809 16.5941 11.5569 16.5941H9.95883V14.8702C9.95883 14.3048 9.52417 13.8359 9.00002 13.8359C8.47588 13.8359 8.04122 14.3048 8.04122 14.8702V16.5941H6.4432C5.91905 16.5941 5.48439 17.063 5.48439 17.6284C5.48439 18.1939 5.91905 18.6628 6.4432 18.6628Z" fill="white" />
                  <path d="M9 0C11.8958 0 14.25 2.35669 14.25 5.25553C14.25 8.09905 12.0284 10.4004 9.13263 10.5C9.04421 10.4889 8.95579 10.4889 8.88947 10.5C8.86737 10.5 8.85632 10.5 8.83421 10.5C8.82316 10.5 8.82316 10.5 8.81211 10.5C5.98263 10.4004 3.76105 8.09905 3.75 5.25553C3.75 2.35669 6.10421 0 9 0Z" fill="white" />
                </svg>
              </button>
            </div>
          </div>

        </div>

      }
      <ToastContainer />
    </div>
  );
}
